const pub = {
     /* 存入cookie */
  setCookie: (key, value, expire, domain) => {
    let textDomain = domain ? ';domain=' + domain : '';
    let exdate;
    if (expire === "null") {
      document.cookie = `${key}=${escape(value)} ; path=/${textDomain}`;
      return;
    } else if (expire === null) {
      exdate = new Date();
      exdate.setHours(exdate.getHours() + 8);
    } else {
      exdate = new Date(parseInt(expire) * 1000);
    }
    document.cookie = `${key}=${escape(value)};expires=${exdate.toGMTString()}; path=/${textDomain}`;
  },
  /* 获取cookie */
  getCookie: (name) => {
    let reg = new RegExp('(^| )' + name + '=([^;]*)(;|$)');
    let arr = document.cookie.match(reg);
    if (arr) {
      return unescape(arr[2]);
    } else {
      return null;
    }
  },

  /* 删除cookie */
  removeCookie: (cookieName) => {
    if (process.browser) {
      var cookies = document.cookie.split(';');
      for (var i = 0; i < cookies.length; i++) {
        if (cookies[i].indexOf(' ') === 0) {
          cookies[i] = cookies[i].substring(1);
        }
        if (cookies[i].indexOf(cookieName) === 0) {
          var exp = new Date();
          exp.setTime(exp.getTime() - 60 * 1000);
          document.cookie = cookies[i] + ';expires=' + exp.toUTCString() + ';path=/';
          break
        }
      }
    }
  }
}
export default pub